import { useContext } from 'react'
import { CustomStore } from '../store'

const useCustomStore = () => {
  return useContext(CustomStore)
}

export default useCustomStore
